module.exports = __webpack_public_path__ + "static/media/photo118.329dbd1a.jpg";